import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const carbonSourceMasterService = createApi({
    reducerPath: 'carbonSourceMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['CarbonSourceMaster'],
    endpoints: (builder) => ({
        getAllCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${body.token}`
                    },
                };
            },
        }),
        getCarbonSourceMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllCarbonSourceMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSourceMasterController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllCarbonSourceMasterMutation,
    useSaveCarbonSourceMasterMutation,
    useUpdateCarbonSourceMasterMutation,
    useDeleteCarbonSourceMasterMutation,
    useGetCarbonSourceMasterByIdMutation,
    useBulkUploadCarbonSourceMasterMutation,
    useFindAllCarbonSourceMasterMutation,
} = carbonSourceMasterService;
